(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const root = document.getElementById('section-{{ section.id }}');
    if(!root) return;

    const expandBtn = root.querySelector('[data-faq-action="expand"]');
    const collapseBtn = root.querySelector('[data-faq-action="collapse"]');
    const items = () => root.querySelectorAll('details.faq-item');

    if (expandBtn) expandBtn.addEventListener('click', () => items().forEach(d => d.open = true));
    if (collapseBtn) collapseBtn.addEventListener('click', () => items().forEach(d => d.open = false));
  })();

  } catch(e) { console.error(e); }
})();
})();
